import { createContext } from "react";

export const tokenContext = createContext<string | null>(null);
export const TokenProvider = tokenContext.Provider;
